import React from "react";
import { cn } from "../../../utils/cn";

export type SettingsTabId = "user-types" | "source-types" | "departments" | "security-logs";

export type SettingsTabItem = {
  id: SettingsTabId;
  label: string;
  description?: string;
};

type SettingsTabNavProps = {
  tabs: SettingsTabItem[];
  activeId: SettingsTabId;
  onChange: (id: SettingsTabId) => void;
};

export function SettingsTabNav({ tabs, activeId, onChange }: SettingsTabNavProps) {
  const active = tabs.find((tab) => tab.id === activeId);

  return (
    <div className="sa-settings-tab-nav">
      <div className="sa-settings-tab-nav__list" role="tablist" aria-label="Settings sections">
        {tabs.map((tab) => {
          const selected = tab.id === activeId;
          return (
            <button
              key={tab.id}
              type="button"
              role="tab"
              id={`sa-settings-tab-${tab.id}`}
              aria-selected={selected}
              aria-controls={`sa-settings-panel-${tab.id}`}
              className={cn("sa-settings-tab-nav__tab", selected && "sa-settings-tab-nav__tab--active")}
              onClick={() => onChange(tab.id)}
            >
              {tab.label}
            </button>
          );
        })}
      </div>
      {active?.description ? (
        <p className="sa-settings-tab-nav__hint">{active.description}</p>
      ) : null}
    </div>
  );
}

export default SettingsTabNav;
